import { render, staticRenderFns } from "./FormControlModulestructureOptions.vue?vue&type=template&id=1bcd591e&scoped=true"
import script from "./FormControlModulestructureOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureOptions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlModulestructureOptions.vue?vue&type=style&index=0&id=1bcd591e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd591e",
  null
  
)

export default component.exports